import { useMemo } from 'react'
import useCursor from './useCursor'
import { useQuery } from '@tanstack/react-query'

const useCursorQuery = <T>(
  cacheKey: (string | undefined)[],
  queryFn: (
    cursor: string | undefined,
  ) => Promise<[T, string | undefined]>,
) => {
  const cacheSymbol = useMemo(
    () => cacheKey.join(''),
    [cacheKey],
  )

  const { cursor, isNext, isPrev, next, prev, add } =
    useCursor(cacheSymbol)

  const queryKey = useMemo(
    () => [...cacheKey, ...(cursor ? [cursor] : [])],
    [cacheKey, cursor],
  )

  const { data, isRefetching, isLoading, ...resultRest } =
    useQuery<T>(queryKey, () =>
      queryFn(cursor).then((response) => {
        const [data, newCursor] = response
        add(newCursor)
        return data
      }),
    )

  return {
    ...resultRest,
    isNext,
    isPrev,
    data,
    isRefetching,
    isLoading,
    cursor,
    next,
    prev,
    add,
  }
}

export default useCursorQuery
